import { ID } from '../types/models/id.model'

const CITY_URL_PREFIX = '-airport-taxi'

export const ROUTES = {
  home: '/',
  contactUs: '/contact-us',
  provider: '/provider',
  search: '/search',
  city: (slug: string) =>
    slug.endsWith(CITY_URL_PREFIX) ? `/${slug}` : `/${slug}${CITY_URL_PREFIX}`,
  helpCenter: '/help/center',
  helpFaq: '/help/faq',
  login: '/auth/login',
  verify: '/auth/verify',
  about: '/about-us',
  blog: '/blog',
  headline: (slug: string) => `/blog/${slug}`,
  post: (slug: string) => `/blog/post/${slug}`,
  support: '/profile/support',
  terms: '/terms-and-conditions',
  privacy: '/privacy-policy',
  tel: (phone: string) => `tel:${phone}`,
  mail: (email: string) => `mailto:${email}`,
  cart: '/cart',
  profile: '/profile/orders',
  profileSettings: '/profile/settings',
  orders: '/profile/orders',
  reviews: '/profile/reviews',
  paymentMethods: '/profile/paymentMethods',
  personalDetails: '/profile/details',
  language: '/profile/language',
  report: '/profile/report',
  faq: '/profile/faq',
  addresses: '/profile/addresses',
  whatsApp: (phoneNumber: string | undefined) =>
    phoneNumber ? `https://wa.me/${phoneNumber}` : '',
  prev: './',
  searchParam: ({ name, value }: { name: string; value: string }) =>
    `?${name}=${value}`,
} as const

export const PROVIDER_ROUTES = {
  base: '/provider',
  login: '/provider/auth/login',
  createAccount: '/provider/auth/create-account',
  verifyAccount: '/provider/auth/verify-account',
  forgotPassword: '/provider/auth/forgot-password',
  resetPassword: '/provider/auth/reset-password',
  bankInformation: '/provider/profile/bank-information',
  companyRegistration: '/provider/profile/company-registration',
  editProfile: '/provider/profile',
  settings: '/provider/profile/settings',
  reservation: '/provider/reserve-trip',
  reservationBookingDetails: '/provider/reserve-trip/booking-details',
  reservationPay: (tripId: ID) => `/provider/reserve-trip/${tripId}/pay`,
  reservationPaymentSucceed: (tripId: ID) =>
    `/provider/reserve-trip/${tripId}/payment-success`,
  reservationPaymentFailed: (tripId: ID) =>
    `/provider/reserve-trip/${tripId}/payment-failed`,

  updateTrip: (tripId: ID) => `/provider/trips/${tripId}/update`,
  updateTripBookingDetails: (tripId: ID) =>
    `/provider/trips/${tripId}/update/booking-details`,
  updateTripPay: (tripId: ID) => `/provider/trips/${tripId}/update/pay`,
  updateTripPaymentSucceed: (tripId: ID) =>
    `/provider/trips/${tripId}/update/payment-success`,
  updateTripPaymentFailed: (tripId: ID) =>
    `/provider/trips/${tripId}/update/payment-failed`,
  tripHistory: '/provider/trip-history',
  tripHistoryDetails: (tripId: ID) => `/provider/trip-history/${tripId}`,
  trips: '/provider/trips',
  upcomingTripDetails: (tripId: ID) => `/provider/trips/${tripId}`,
} as const

export const QUERY_ROUTES = {
  login: { name: 'auth', value: 'login' },
  register: { name: 'auth', value: 'register' },
  forgotPassword: { name: 'auth', value: 'forgot-password' },
  verify: { name: 'auth', value: 'verify' },
  resetPassword: { name: 'auth', value: 'reset-password' },
  cancelTrip: { name: 'action', value: 'cancel' },
  tripPayment: (id: string) => ({ name: 'trip-id', value: id }),
  tripPaymentStatus: (status: string) => ({ name: 'payment', value: status }),
  sendVerificationCode: { name: 'auth', value: 'send-verification-code' },
  verifyPhone: { name: 'auth', value: 'verify-account' },
  returnTo: { name: 'return-to', value: (path: string) => path },
  search: {
    name: 'search',
    value: (query: string) => query,
  },
} as const
